import PageHero, { usePageTitle } from "@/components/PageHero";
import SectionHeader from "@/components/SectionHeader";
import EcosystemGrid from "@/components/EcosystemGrid";
import CTABand from "@/components/CTABand";
import { Reveal } from "@/components/Reveal";
import { ArrowDown } from "lucide-react";

const FLOW = ["Estrategia", "Ejecución", "Inteligencia", "Valor"];

export default function Ecosistema() {
  usePageTitle("Ecosistema BRIK | Divisiones especializadas en Procurement");
  return (
    <>
      <PageHero
        eyebrow="Ecosistema BRIK"
        titleLines={["Un ecosistema especializado", "para transformar Procurement."]}
        description="Un portafolio de divisiones especializadas para cubrir todas las necesidades de Procurement."
        image="/brand/ref-port.webp"
        alt="BRIK Global — sourcing internacional y comercio exterior"
      />

      <section data-testid="ecosystem-detail" className="bg-bone">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32">
          <SectionHeader
            eyebrow="Ecosistema BRIK"
            title="Distintas capacidades. Una sola visión."
            description="Nuestro ecosistema integra soluciones especializadas para acompañar a las empresas en diferentes necesidades y etapas de su función de Compras. Cada BRIK puede operar de forma independiente o combinarse para construir una solución a la medida."
          />
          <div className="mt-14">
            <EcosystemGrid />
          </div>
          <Reveal delay={0.2}>
            <div className="mt-20 lg:mt-24 max-w-4xl mx-auto text-center">
              <span className="inline-block h-px w-16 bg-gold mb-8" />
              <p className="font-display text-xl lg:text-2xl font-semibold text-oxford leading-snug">
                “No todas las empresas necesitan lo mismo. Por eso no ofrecemos una solución única: combinamos los BRIKs necesarios para construir la capacidad de Compras que cada negocio necesita.”
              </p>
              <span className="inline-block h-px w-16 bg-gold mt-8" />
            </div>
          </Reveal>
        </div>
      </section>

      <section data-testid="synergy-band" className="relative bg-oxford diagonal-lines overflow-hidden">
        <img src="/brand/isotipo-gold.webp" alt="" className="absolute -right-20 -bottom-24 w-96 opacity-[0.05] pointer-events-none" />
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32">
          <SectionHeader
            dark
            eyebrow="Sinergia"
            title="Cada división potencia a las demás."
            description="Operamos como un sistema integrado: la estrategia alimenta la ejecución, la ejecución genera datos y los datos fortalecen cada negociación."
          />
          <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10">
            {FLOW.map((step, i) => (
              <Reveal key={step} delay={i * 0.15}>
                <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-10">
                  <div className="flex flex-col items-center gap-3">
                    <span className="font-display text-4xl font-bold text-gold/40">0{i + 1}</span>
                    <span className="font-display text-sm font-semibold tracking-[0.25em] uppercase text-white">{step}</span>
                  </div>
                  {i < FLOW.length - 1 && <ArrowDown className="h-5 w-5 text-gold rotate-0 sm:-rotate-90" strokeWidth={1.5} />}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand
        title="Activa el ecosistema BRIK para tu empresa."
        text="Desde operar tu departamento de Compras hasta desarrollar a tu equipo: hay una división BRIK para cada necesidad."
        cta="Hablemos"
      />
    </>
  );
}
